enum Place {
  JIZDARNA = "Jízdárna",
  ZAMEK = "Zámek",
  CAFE = "Café"
}
export default Place;
